export default "__VITE_ASSET__BDmVCIMP__"